import { render, staticRenderFns } from "./SearchSection.vue?vue&type=template&id=0a087d6e&scoped=true&"
import script from "./SearchSection.vue?vue&type=script&lang=js&"
export * from "./SearchSection.vue?vue&type=script&lang=js&"
import style0 from "./SearchSection.vue?vue&type=style&index=0&id=0a087d6e&scoped=true&lang=css&"
import style1 from "./SearchSection.vue?vue&type=style&index=1&id=0a087d6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a087d6e",
  null
  
)

export default component.exports